import axios from 'axios'
import store from '../../redux/store/store'
import { LOGOUT } from '../../redux/actions/types'
import { getLang, DEFAULT_LANG } from '../../i18n'

/* ══════════════════════════════════════════════════════════════════════════
   F1 — צירוף שפת-הממשק לכל קריאת-API, בנקודה **אחת**.

   ★★ למה interceptor ולא פרמטר בכל callsite: השרת צריך את השפה בשלושה
      הקשרים שונים (תרגום שמות-מחלקות/יומנים, הודעות-שגיאה שחוזרות למסך,
      ושמירת `visitors.lang` בהזמנה). פיזור הפרמטר על עשרות קריאות היה
      מבטיח שאחת תישכח — וזו בדיוק הייתה מחזירה עברית באמצע ממשק ערבי.
   ★ עברית אינה נשלחת: היא ברירת-המחדל בשרת, וכך ה-URLים נשארים זהים לחלוטין
     למה שהיה עד היום עבור **כל** הלקוחות הקיימים.
   ══════════════════════════════════════════════════════════════════════════ */
let langInterceptorAdded = false
const setupLangInterceptor = () => {
  if (langInterceptorAdded) return
  langInterceptorAdded = true
  axios.interceptors.request.use(config => {
    try {
      const lang = getLang()
      if (lang && lang !== DEFAULT_LANG) {
        /* ⚠️ מצורף ל-`params` ולא לתוך ה-URL: axios מטפל בקידוד ובחיבור
           ה-`?`/`&`, ולכן זה עובד גם על קריאות שכבר נושאות query. */
        config.params = { ...(config.params || {}), lang }
      }
    } catch (e) { /* שפה היא שיפור-תצוגה — לעולם לא לחסום בקשה בגללה */ }
    return config
  }, error => Promise.reject(error))
}

// Add the 401 RESPONSE interceptor exactly once (setAuthToken runs on every login/logout).
let responseInterceptorAdded = false
const setupResponseInterceptor = () => {
  if (responseInterceptorAdded) return
  responseInterceptorAdded = true
  axios.interceptors.response.use(
    response => response,
    error => {
      const status = error && error.response && error.response.status
      // A 401 on an authenticated call means our token is no longer valid — most often because the
      // SAME account signed in on ANOTHER device. The backend keeps a single token per user (each
      // login rotates it), so the older device's token stops working. Instead of a confusing empty /
      // "no appointments" state, end the session cleanly and let the login screen explain.
      // Guard on an existing token so a plain unauthenticated 401 doesn't loop.
      if (status === 401 && localStorage.getItem('token')) {
        localStorage.removeItem('token')
        try { sessionStorage.setItem('sessionEnded', '1') } catch (e) { /* storage disabled */ }
        store.dispatch({ type: LOGOUT })
      }
      return Promise.reject(error)
    }
  )
}

const setupAxios = (accessToken, formFunc) => {
  // ** Request Interceptor
  axios.interceptors.request.use(
    config => {
      if (accessToken) {
        if (!config.headers.common) {
          config.headers['Authorization'] = `Bearer ${localStorage.getItem("token")}`;
        } else {
          config.headers.common['Authorization'] = `Bearer ${localStorage.getItem("token")}`;//accessToken}`

        }
      } else {
        delete axios.defaults.headers.common['Authorization']
      }

      return config
    },
    error => Promise.reject(error)
  )

  setupResponseInterceptor()
}

const setAuthToken = accessToken => {
  console.log(accessToken)
  setupAxios(accessToken, true)
}

// register the response interceptor on import too, so a stale token is caught even before the first login
setupResponseInterceptor()
// ★ ה-lang נדרש כבר בקריאות שלפני ההתחברות (‏site-config, שליחת-OTP), ולכן
//   נרשם באותה נקודה ולא בתוך `setupAxios` (שרץ רק בלוגין/לוגאאוט).
setupLangInterceptor()

export default setAuthToken
